<template>
  <div>
    <el-table class="table_box pc_table_box" :data="pageData" style="width: 100%" v-loading="loading"
              element-loading-background="rgba(0, 0, 0, 0.8)" :row-style="{ height: '59px' }"
    >
      <el-table-column prop="order" :label="$t('copy_trading_address')" width="360px"></el-table-column>
      <el-table-column prop="nextTime" :label="$t('position_duration')">
        <template slot-scope="scope">
          <div>{{ scope.row.nextTime }}D</div>
        </template>
      </el-table-column>
      <el-table-column prop="symbol" :label="$t('currency')"></el-table-column>
      <el-table-column prop="share" :label="$t('copy_share')"></el-table-column>
      <el-table-column prop="profit" :label="$t('copy_profit')">
        <template slot-scope="scope">
          <div :class="parseFloat(scope.row.profit)>=0?'long':'short'"
               :style="{color:parseFloat(scope.row.profit)>=0?'rgba(165, 214, 63, 1) !important':'rgba(239, 69, 74, 1) !important'}">
            {{ scope.row.profit }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="mobile_table_box mobile_list" v-loading="loading" style="margin-top: 22px"
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <div :class="'item1'" v-for="(item,index) in tableData6" :key="index">
        <div :class="'item'">
          <div style="flex: 1;">
            <div class="title">
              {{ $t('copy_trading_address') }}
            </div>
            <div class="value" style="word-break: break-all">
              {{ item.order }}
            </div>
          </div>


          <div style="flex: 1;">
            <div class="title right">
              {{ $t('position_duration') }}
            </div>
            <div class="value right">
              {{ item.nextTime }}D
            </div>
          </div>
        </div>
        <div :class="'item'" style="margin-top: 12px;">
          <div>
            <div class="title">
              {{ $t('currency') }}
            </div>
            <div class="value">
              {{ item.symbol }}
            </div>
          </div>

          <div>
            <div class="title">
              {{ $t('copy_share') }}
            </div>
            <div class="value">
              {{ item.share }}
            </div>
          </div>

          <div>
            <div class="title right">
              {{ $t('copy_profit') }}
            </div>
            <div :class="'value right ' + (parseFloat(item.profit)>=0?'long':'short')">
              {{ item.profit }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-pagination @prev-click="prevClick()"
                   @next-click="nextClick()"
                   :page-size="pageSize"
                   align="right"
                   :current-page.sync="currentPage"
                   layout="prev, pager, next"
                   style="margin-bottom: 200px"
                   :total="this.tableData6.length"/>
  </div>

</template>

<script>
import {createAndCall, createLeadingContractAndCall, getSelectTokenInfo} from "../utils/contract";
import {Method, Underling} from "../config/const";
import {transBig2number, transNumber2Big, transTime2Date} from "../utils/functions";
import {BigNumber} from "ethers";
import {getTransData} from "../service/queryService";
import {getAccount} from "../utils/wallet";
import {getLastPrice} from "../service/priceService";

export default {
  name: "activate6",
  props: {
    contractAddress: "",
    token: ""
  },
  data() {
    return {
      tableData6: [],
      loading: false,
      currentPage:1,
      pageSize:10,
      pageData:[]
    }
  },
  watch:{
    currentPage(val){
      this.setPage(val)
    }
  },
  methods: {
    getSubDate(time) {
      return Math.floor(((new Date().getTime() / 1000) - time) / 86400 + 1);
    },
    prevClick(e) {
      this.currentPage--
    },
    nextClick(e) {
      console.log(e)
      this.currentPage++
    },
    setPage(val){
      let start=(val - 1) * this.pageSize;
      this.pageData=this.tableData6.slice(start,start+this.pageSize)
    },
    async getData() {
      if (!this.contractAddress) {
        return;
      }

      //跟单收益=实时份额价值*份额 + 转出份额价值*转出份额 - 总转入币总数量

      let price = await getLastPrice()
      let priceBTC = transBig2number(price[Underling.BTC].price, price[Underling.BTC].decimal, 6);
      let priceETH = transBig2number(price[Underling.ETH].price, price[Underling.ETH].decimal, 6);

      let priceBtcNum = transNumber2Big(priceBTC);
      let priceEthNum = transNumber2Big(priceETH);
      let tokenInfo = await getSelectTokenInfo(this.token)

      //获取实时份额价值
      let asset = await createLeadingContractAndCall(this.contractAddress, Method.getTotalBalance, [Underling.BTC, Underling.ETH], [priceBtcNum, priceEthNum]);
      let totalShare = await createLeadingContractAndCall(this.contractAddress, Method.totalShare);
      let shareRate = 0;
      if (totalShare.eq(BigNumber.from(0))) {
        shareRate = 0;
      } else {
        let shareValue = asset.assetAmount.mul(BigNumber.from(10000)).div(totalShare)
        shareRate = parseFloat(shareValue.toString()) / 10000;
      }
      let transLog = await getTransData("", this.contractAddress, 0)

      let followers = await createLeadingContractAndCall(this.contractAddress, Method.getFollowersInfo);
      this.tableData6 = [];
      for (let i in followers) {
        let obj = {
          order: followers[i].userAddress,
          nextTime: this.getSubDate(parseInt(followers[i].firstFollowTime)),
          symbol: tokenInfo.symbol,
          profit: ""
        }

        let user = followers[i].userAddress.toLowerCase();
        let asset = await createLeadingContractAndCall(this.contractAddress, Method.userShares, user);
        let profit = BigNumber.from(0);

        obj.share = transBig2number(asset);

        profit = asset.mul(BigNumber.from(parseInt(shareRate * 1000000))).div(BigNumber.from(1000000));
        for (let i in transLog.transformTokens) {
          let logItem = transLog.transformTokens[i];
          if (logItem.user != user) {
            continue;
          }
          if (!logItem.isDeposit) {
            profit = profit.add(BigNumber.from(logItem.amount))
          } else {
            profit = profit.sub(BigNumber.from(logItem.amount))
          }
        }
        obj.profit = transBig2number(profit);
        this.tableData6.push(obj);
        this.currentPage=1;
        this.setPage(1)
      }


    },
    async init() {
      this.loading = true;
      await this.getData();
      this.loading = false;
    }
  },
  created() {
    // this.init()
  }
}
</script>

<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style scoped lang="less">
.el-table, .el-table__expanded-cell {
  background-color: rgba(24, 26, 32, 1);
}

::v-deep .el-button--primary {
  background: none;
}

.mobile_list {
  margin-bottom: 20px;
  margin-bottom: 20px;
  display: flex !important;
  flex-direction: column;
  gap: 23px;
  .item1 {
    padding-left: 25px;
    padding-right: 25px;
    border-bottom: 0.2px solid rgba(90, 90, 93, 1);
    padding-bottom: 23px;
    .item{
      display: flex;
      justify-content: space-between;
    }
  }

  .right {
    text-align: right;
  }

  .value {
    margin-top: 6px;
  }

}

.long {
  color: rgba(165, 214, 63, 1) !important;
}

.short {
  color: rgba(239, 69, 74, 1) !important;
}

@media (max-width: 750px) {
  .title{
    font-size: 11px !important;
    line-height: revert;
  }
}

</style>
<style src="../assets/css/mobile.scss" lang="scss" scoped></style>
